import { useDelegateContext } from '@features/delegate-context/useDelegateContext';
import { STAKEHOLDER_HOME_ROUTE } from '@routes/constants';
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

/** Pages a delegate acting for a stakeholder can't use send them to the stakeholder home. */
const OwnAccountGuard = () => {
  const { stakeholder } = useDelegateContext();
  return stakeholder ? <Navigate to={STAKEHOLDER_HOME_ROUTE} replace /> : <Outlet />;
};

export const Route = createFileRoute('/_authenticated/_shell/_ownAccount')({ component: OwnAccountGuard });
